<template>
  <div class="columns mgt-20px is-multiline">
    <div class="column is-12">
      <div class="card">
        <header class="header-card">
          <p> {{ $t('societes.mentionsLegales.retardPaiement') }} </p>
        </header>
        <div class="card-content">
          <div class="column is-12">
            <qd-text-editor v-model="societe.retardPaiement" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    societe: {
      type: Object,
      required: true,
    },
  },
};

</script>
